import React, { useState, useEffect, useCallback } from 'react';

const readTheme = () =>
  document.documentElement.classList.contains('dark') ? 'dark' : 'light';

const applyTheme = (t) => {
  localStorage.setItem('theme', t);
  document.documentElement.classList.toggle('dark', t === 'dark');
  document.documentElement.setAttribute('data-theme', t);
  document.querySelector('.App')?.setAttribute('data-theme', t);
};

// Provider bleibt nur als Durchreicher, falls er irgendwo noch importiert wird.
export function AppThemeProvider({ children }) {
  return <>{children}</>;
}

// Kein Provider noetig: liest die dark-Klasse auf <html> und bleibt synchron.
export function useAppTheme() {
  const [theme, setThemeState] = useState(readTheme);

  useEffect(() => {
    const obs = new MutationObserver(() => setThemeState(readTheme()));
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    return () => obs.disconnect();
  }, []);

  const setTheme = useCallback((t) => { applyTheme(t); setThemeState(t); }, []);
  const toggleTheme = useCallback(() => setTheme(readTheme() === 'dark' ? 'light' : 'dark'), [setTheme]);

  return { theme, setTheme, toggleTheme };
}
